export default "__VITE_ASSET__DFH2kNZ3__"